import { render, staticRenderFns } from "./shop-info-page.vue?vue&type=template&id=09ff8565&scoped=true"
import script from "./shop-info-page.vue?vue&type=script&lang=js"
export * from "./shop-info-page.vue?vue&type=script&lang=js"
import style0 from "./shop-info-page.vue?vue&type=style&index=0&id=09ff8565&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09ff8565",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/lib/jenkins/workspace/快电商/preview-qcommerce-h5/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('09ff8565')) {
      api.createRecord('09ff8565', component.options)
    } else {
      api.reload('09ff8565', component.options)
    }
    module.hot.accept("./shop-info-page.vue?vue&type=template&id=09ff8565&scoped=true", function () {
      api.rerender('09ff8565', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/h5/shop-info-page.vue"
export default component.exports